export const styles = {
  text: {
    // display: "inline",
    width: "100%",
    fontFamily: "var(--font-family)",
    fontSize: "16px",
    paddingBottom: "10px",
    paddingTop: "35px",
  },
  read_or_hide: {
    color: "var(--secondary-color)",
    fontWeight: "bold",
    cursor: "pointer",
  },
};
